import type { ComponentLike } from "@glint/template";

declare const IconsExternalLink: ComponentLike<{ Element: SVGElement }>;
export default IconsExternalLink;
